module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-file-small"
  }, [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("unarchive")]), _vm._v(_vm._s(_vm.i18n().load) + "\n  ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.handleInputChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c19a3942"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/LoadFileSmall.vue
// module id = 467
// module chunks = 0